/**
 * @Description 选址地图青春版本
 */

import { get, post } from '../request';

const OPTIONS = { isMock: false, mockId: 0, mockSuffix: '/api', needHint: true };

/** 选址地图青春版-相似商圈卡片 */
export function getSimilarBusinessCircleList(params: any) {
  return post('/youth/map/modelCluster/similar/list', params, OPTIONS);
}

/** 选址地图青春版-相似商圈卡片（分享） */
export function getShareSimilarBusinessCircleList(params: any) {
  return post('/youth/map/modelCluster/share/similar/list', params, OPTIONS);
}

/**
 * 竞品下拉 (返回品牌数量)
 * https://yapi.lanhanba.com/project/532/interface/api/98752
 */
export function getYouthBrand(params:any) {
  return get(`/youth/map/industry/brand/search`, params, { needCancel: false });
}

/**
 * 品牌数量
 * https://yapi.lanhanba.com/project/546/interface/api/98798
 */
export function getYouthBrandCount(params:any) {
  return post(`/youth/map/industry/brand/count`, params, { needCancel: false });
}

/**
 * 竞品品牌开店趋势
 * https://yapi.lanhanba.com/project/349/interface/api/86162
 */
export function brandMonthTendency(params: any) {
  return get('/youth/map/queryMonthTendency', { ...params });
}
/**
 * 地图品牌数量top6
 * https://yapi.lanhanba.com/project/349/interface/api/88764
 */
export function brandShopCountList(params: any) {
  return post('/youth/map/getBrandShopCountList', { ...params });
}

/**
 * 关注品牌top6
 * https://yapi.lanhanba.com/project/349/interface/api/92852
 */
export function attentionBrandTop(params: any) {
  return post('/youth/map/combatMap/queryTendencyV2', { ...params }, { needCancel: false });
}

/**
 * 本品牌开店趋势
 * https://yapi.lanhanba.com/project/349/interface/api/86666
 */
export function queryOpeningTendency(params: any) {
  return get('/youth/map/queryOpeningTendency', { ...params });
}
/**
 * 商圈-概览基础信息
 * https://yapi.lanhanba.com/project/546/interface/api/88398
 */
export function getOverviewBase(params: any) {
  return post('/youth/map/modelCluster/overview/base', params);
}

/**
 * 商圈-评分数据
 * https://yapi.lanhanba.com/project/546/interface/api/88776
 */
export function getClusterScores(params: any) {
  return post('/youth/map/modelCluster/scores', params);
}
/**
 * 分享-商圈-评分数据
 * https://yapi.lanhanba.com/project/546/interface/api/88776
 */
export function getShareClusterScores(params: any) {
  return post('/youth/map/modelCluster/share/scores', params);
}

/**
 * 分享商圈客流热力数据
 * https://yapi.lanhanba.com/project/546/interface/api/100482
 * id 为加密后的商圈 ID，接口返回商圈中心点、围栏和热力数据地址。
 */
export function getShareMxxPassengerFlow(params: any) {
  return post('/youth/map/modelCluster/share/hotMap/mxxPassengerFlow', params, { isMock: false, mockId: 546 });
}

/**
 * 同步生成分享图片地址
 * https://yapi.lanhanba.com/project/546/interface/api/100488
 * 与 asyncV2 的请求结构一致，但直接返回 { url, name, type }，不返回异步任务布尔值。
 */
export function getShareImageUrl(params: any) {
  return post('/youth/map/modelCluster/share/imageUrl', params, { isMock: false, mockId: 546 });
}


/**
 * 商圈-商圈内包含信息
 * https://yapi.lanhanba.com/project/546/interface/api/88404
 */
export function getClusterBrands(params: any) {
  return post('/youth/map/modelCluster/containInfo', params);
}


/**
 * 查询打卡任务
 * https://yapi.lanhanba.com/project/546/interface/api/88220
 */
export function postCheckInQueryTaskModelList(params: any) {
  return post('/standard/checkIn/queryTaskModelList', { ...params });
}

/**
 * 创建打卡任务
 * https://yapi.lanhanba.com/project/546/interface/api/88218
 */
export function postCheckInCreateTask(params: any) {
  return post('/standard/checkIn/createTask', { ...params });
}

/**
 * 商圈-人口数据
 * https://yapi.lanhanba.com/project/546/interface/api/88430
 */
export function getPopulationInfo(params: any) {
  return post('/youth/map/modelCluster/population', params, { isMock: false, mockId: 546, mockSuffix: '/api' });
}
// /**
//  * 分享-商圈-人口数据
//  * https://yapi.lanhanba.com/project/546/interface/api/88578
//  */
// export function getSharePopulationInfo(params: any) {
//   return post('/youth/map/modelCluster/share/population', params);
// }
/**
 * 商圈-经营门店tab
 * https://yapi.lanhanba.com/project/546/interface/api/88564
 */
export function getStoreTabs(params: any) {
  return post('/youth/map/modelCluster/surround/levelCount', params);
}
/**
 * 分享-商圈-经营门店tab
 * https://yapi.lanhanba.com/project/546/interface/api/88564
 */
export function getShareStoreTabs(params: any) {
  return post('/youth/map/modelCluster/share/surround/levelCount', params);
}
/**
 * 商圈-经营门店列表-poi
 * https://yapi.lanhanba.com/project/546/interface/api/88566
 */
export function getStorePoiList(params: any, config?:any) {
  return post('/youth/map/modelCluster/surround/poi/levelPage', params, config);
}
/**
 * 分享-商圈-经营门店列表-poi
 * https://yapi.lanhanba.com/project/546/interface/api/88582
 */
export function getShareStorePoiList(params: any, config?:any) {
  return post('/youth/map/modelCluster/share/surround/poi/levelPage', params, config);
}
/**
 * 商圈-经营门店列表-知名品牌
 * https://yapi.lanhanba.com/project/546/interface/api/88568
 */
export function getStoreFamousList(params: any, config?:any) {
  return post('/youth/map/modelCluster/surround/famousBrand/levelPage', params, config);
}
/**
 * 分享-商圈-经营门店列表-知名品牌
 * https://yapi.lanhanba.com/project/546/interface/api/88584
 */
export function getShareStoreFamousList(params: any, config?:any) {
  return post('/youth/map/modelCluster/share/surround/famousBrand/levelPage', params, config);
}
/**
 * 商圈-经营门店列表-竞品门店
 * https://yapi.lanhanba.com/project/349/interface/api/90007
 */
export function getStoreCompetitorsList(params: any, config?:any) {
  return post('/youth/map/modelCluster/surround/competitors/levelPage', params, config);
}
/**
 * 分享-商圈-经营门店列表-竞品门店
 * https://yapi.lanhanba.com/project/546/interface/api/88586
 */
export function getShareStoreCompetitorsList(params: any, config?:any) {
  return post('/youth/map/modelCluster/share/surround/competitors/levelPage', params, config);
}

/**
 * 品牌商圈（大圈）-详情
 * https://yapi.lanhanba.com/project/349/interface/api/91369
 */
export function getYouthModelCapacityDetail(params: any, config?:any) {
  return post('/youth/map/modelCapacity/detail', params, config);
}

/**
 * 市场容量（大圈）详情-门店列表
 * https://yapi.lanhanba.com/project/349/interface/api/91423
 */
export function getYouthModelCapacityDetailShopPage(params: any, config?:any) {
  return post('/youth/map/modelCapacity/detail/shopPage', params, config);
}

/**
 * 市场容量（大圈）详情-Mall列表
 * https://yapi.lanhanba.com/project/349/interface/api/91414
 */
export function getYouthModelCapacityDetailMallPage(params: any, config?:any) {
  return post('/youth/map/modelCapacity/detail/mallPage', params, config);
}

/**
 * 市场容量（大圈）详情-Mall地图简单列表
 * https://yapi.lanhanba.com/project/349/interface/api/91918
 */
export function getYouthModelCapacityDetailMallSimplePage(params: any, config?:any) {
  return post('/youth/map/modelCapacity/detail/mallSimplePage', params, config);
}

/**
 * 开店区域（小圈）-详情
 * https://yapi.lanhanba.com/project/623/interface/api/88638
 */
export function getYouthModelClusterDetail(params: any, config?:any) {
  return get('/youth/map/modelCluster/detail', params, config);
}

/**
 * 获取品牌商圈列表
 * https://yapi.lanhanba.com/project/546/interface/api/88998
 */
export function getBrandPolygonList(params:any) {
  return post(`/customBrandCluster/page`, params);
}

/**
 * 选址地图青春版-区域保护列表(开启地图要素显示-区域保护)
 * https://yapi.lanhanba.com/project/546/interface/api/89014
 */
export function regionalProtectionList(params: any) {
  return post('/youth/map/layer/regionalProtection', params);
}


/**
 * 选址地图青春版-品牌商圈-hover信息
 * https://yapi.lanhanba.com/project/546/interface/api/89258
 */
export function postYouthHoverRemark(params: any) {
  return post('/youth/map/modelCapacity/hover', params);
}


/**
 * 选址地图青春版-品牌商圈-保存备注
 * https://yapi.lanhanba.com/project/532/interface/api/89170
 */
export function postYouthSaveRemark(params: any) {
  return post('/youth/map/modelCapacity/saveRemark', params);
}


/**
 * 选址地图青春版-品牌商圈-竞品数据
 * https://yapi.lanhanba.com/project/546/interface/api/89262
 */
export function postYouthModelCapacityCompetitorsData(params: any) {
  return post('/youth/map/modelCapacity/competitorsData', params);
}

/**
 * 选址地图青春版-品牌商圈-商圈分布-商圈类型数据
 * https://yapi.lanhanba.com/project/546/interface/api/89264
 */
export function postYouthModelCapacityClusterCategory(params: any) {
  return post('/youth/map/modelCapacity/clusterCategory', params);
}

/**
 * 选址地图青春版-品牌商圈-商圈分布-人口分布
 * https://yapi.lanhanba.com/project/546/interface/api/89260
 */
export function postYouthModelCapacityPopulation(params: any) {
  return post('/youth/map/modelCapacity/population', params);
}

/**
 * 选址地图青春版-全国-省卡片
 * https://yapi.lanhanba.com/project/349/interface/api/89252
 */
export function postYouthProvinceCard(params: any) {
  return post('/youth/map/card/getProvinceCard', params);
}

/**
 * 选址地图青春版-全国-市卡片
 * https://yapi.lanhanba.com/project/349/interface/api/89254
 */
export function postYouthCityCard(params: any) {
  return post('/youth/map/card/getCityCard', params);
}

/**
 * 选址地图青春版-默认配置
 * https://yapi.lanhanba.com/project/349/interface/api/88446
 */
export function getYouthMapDefaultConfig(params: any) {
  return get('/youth/map/defaultConfig', params);
}

/**
 * 选址地图-默认配置（分享）
 * https://yapi.lanhanba.com/project/349/interface/api/97652
 */
export function postShareYouthMapDefaultConfig(params: any) {
  return post('/spot/evaluation/share/defaultConfig', params);
}

/**
 * 当前租户详情_copy
 * https://yapi.lanhanba.com/project/532/interface/api/85679
 */
export function getTenantShareInfo(params: any) {
  return get('/tenant/shareInfo', params);
}


/**
 * 选址地图青春版-地图中的获取分公司列表信息
 * https://yapi.lanhanba.com/project/546/interface/api/89609
 */
export function branchCompanyYouthMap(params: any) {
  return post('/youth/map/branchCompany/map', params);
}

/**
 * 选址地图青春版-全国分公司hover后的概览信息
 * https://yapi.lanhanba.com/project/546/interface/api/89702
 */
export function branchCompanyOverview(params: any) {
  return post('/youth/map/branchCompany/overview', params, {
    needCancel: false
  });
}

/**
 * 选址地图青春版-分公司下城市hover后的概览信息
 * https://yapi.lanhanba.com/project/546/interface/api/89747
 */
export function branchCompanyCityOverview(params: any) {
  return post('/youth/map/branchCompany/overview/city', params);
}

/**
 * 分公司-竞品品牌数量top6
 * https://yapi.lanhanba.com/project/546/interface/api/89705
 */
export function companyCompetitorList(params: any) {
  return post('/youth/map/branchCompany/getBrandShopCountList', { ...params });
}

/**
 * 分公司-本品牌开店趋势
 * https://yapi.lanhanba.com/project/546/interface/api/89735
 */
export function companyOpeningTendency(params: any) {
  return post('/youth/map/branchCompany/queryOpeningTendency', { ...params });
}

/**
 * 分公司-竞品品牌开店趋势
 * https://yapi.lanhanba.com/project/546/interface/api/89732
 */
export function companyCompetitorMonthTendency(params: any) {
  return post('/youth/map/branchCompany/queryMonthTendency', { ...params });
}


/**
 * 获取拥有权限的城市数据
 * https://yapi.lanhanba.com/project/546/interface/api/89816
 */
export function getCompanyCityPermission() {
  return get(`/youth/map/branchCompany/permission/city`);
}

/**
 * 周边配套 tab接口（返回一二级tab及对应数量）
 * https://yapi.lanhanba.com/project/349/interface/api/89877
 */
export function youthArroundCategory(params: any, config?: any) {
  return post('/youth/map/surround/model/arroundCategory', { ...params }, config);
}

/**
 * 周边配套 tab接口（返回一二级tab及对应数量）-分享使用
 * https://yapi.lanhanba.com/project/349/interface/api/89879
 */
export function youthShareArroundCategory(params: any, config?: any) {
  return post('/youth/map/surround/share/model/arroundCategory', { ...params }, config);
}

/**
 * 周边配套-分页列表接口
 * https://yapi.lanhanba.com/project/349/interface/api/89873
 */
export function youthAroundPage(params:any, config?: any) {
  return post(`/youth/map/surround/model/aroundPage`, params, config);
}

/**
 * 周边配套-分页列表接口-分享使用
 * https://yapi.lanhanba.com/project/349/interface/api/89875
 */
export function youthShareAroundPage(params:any, config?: any) {
  return post(`/youth/map/surround/share/model/aroundPage`, params, config);
}

/**
 * 周边配套-查询周边小区聚合信息
 * https://yapi.lanhanba.com/project/349/interface/api/98200
 */
export function surroundCommunityAggregate(params: any, config?: any) {
  return post('/youth/map/surround/community/aggregate', { ...params }, config);
}

/**
 * 周边配套-查询周边小区聚合信息(分享)
 * https://yapi.lanhanba.com/project/349/interface/api/98200
 */
export function surroundShareCommunityAggregate(params: any, config?: any) {
  return post('/youth/map/surround/share/community/aggregate', { ...params }, config);
}

/**
 * 筛选项(基础筛选+布局)
 * https://yapi.lanhanba.com/project/349/interface/api/89903
 */
export function getYouthMapSelections(params) {
  return get('/youth/map/selections', params, { needCancel: false, isMock: false, mockId: 349, mockSuffix: '/api' });
}

/**
 * 选址地图-筛选项配置(商圈显示筛选)
 * https://yapi.lanhanba.com/project/349/interface/api/88604
 */
export function getYouthMapScreeningList(params) {
  return post('/youth/map/screeningList', params, { mockId: 349, isMock: false });
}

/**
 * 周边配套 tab接口（返回一二级tab及对应数量）（导出用）
 * https://yapi.lanhanba.com/project/546/interface/api/90343
 */
export function youthArroundCategoryPDF(params: any, config?: any) {
  return post('/youth/map/modelCluster/pdf/model/arroundCategory', { ...params }, config);
}

/**
 * 周边配套 poi分页列表(导出)
 * https://yapi.lanhanba.com/project/546/interface/api/90379
 */
export function youthArroundCategoryPDFPoiPage(params:any, config?: any) {
  return post(`/youth/map/modelCluster/pdf/poi/page`, params, config);
}

/**
 * 周边配套 点位测评-导出-pdf-周边配套-批量查询poi分页列表
 * https://yapi.lanhanba.com/project/546/interface/api/90379
 */
export function postSpotEvaluationExportPdfArroundPageBatch(params:any, config?: any) {
  return post(`/spot/evaluation/export/pdf/arroundPage/batch`, params, config);
}

/**
 * 周边配套-查询周边小区聚合信息(导出)
 * https://yapi.lanhanba.com/project/349/interface/api/98524
 */
export function youthModelClusterPDFCommunityAggregate(params:any, config?: any) {
  return post(`/youth/map/modelCluster/pdf/surround/community/aggregate`, params, config);
}

/**
 * 商场详情
 * https://yapi.lanhanba.com/project/329/interface/api/99134
 */
export function getPlaceMallDetail(params) {
  return post('/place/mall/detail', params, { isMock: false, mockId: 329 });
}

/**
 * 商圈-商场客流
 * https://yapi.lanhanba.com/project/349/interface/api/91945
 */
export function getYouthMapModelClusterFlow(params) {
  return post('/youth/map/modelCluster/flow', params);
}

/**
 * 商圈-商场客流v2
 * https://yapi.lanhanba.com/project/349/interface/api/99848
 */
export function getYouthMapModelClusterFlowV2(params) {
  return post('/youth/map/modelCluster/flowV2', params);
}

/**
 * 商圈-商场日客流对比
 * https://yapi.lanhanba.com/project/349/interface/api/99844
 */
export function getYouthMapModelClusterFlowCompare(params) {
  return post('/youth/map/modelCluster/flow/compare', params);
}

/**
 * 获取全国商场排名 CDN 文件地址
 * https://yapi.lanhanba.com/project/349/interface/api/99846
 */
export function getYouthMapModelClusterMallFlowRankCdnUrl(params) {
  return get('/youth/map/modelCluster/mallFlow/rank/cdnUrl', params);
}

/**
 * 获取模型商圈客流系数
 * https://yapi.lanhanba.com/project/349/interface/api/99854
 */
export function getYouthMapModelClusterMallFlowCoefficient(params) {
  return get('/modelCluster/mallFlowCoefficient', params);
}

/**
 * 【青春版】商圈是否已有本品牌在营门店入驻
 * https://yapi.lanhanba.com/project/623/interface/api/89336
 */
export function getYouthMapModelClusterGetSettledInfo(params) {
  return post('/youth/map/modelCluster/getSettledInfo', params);
}

/**
 * 查询最新的统计日期
 * https://yapi.lanhanba.com/project/546/interface/api/93028
 */
export function getYouthMapIndustryInsuranceVolumeLatestDate(params?: any) {
  return post('/youth/map/industry/insurance/volume/latestDate', params, { mockId: 546, isMock: false });
}

/**
 * 查询最新的统计日期（分享）
 * https://yapi.lanhanba.com/project/349/interface/api/97580
 */
export function getShareYouthMapIndustryInsuranceVolumeLatestDate(params?: any) {
  return post('/spot/evaluation/share/insurance/volume/latestDate', params, { mockId: 546, isMock: false });
}

/**
 * 全国上险量查询（包含本品牌上险量）
 * https://yapi.lanhanba.com/project/546/interface/api/92932
 */
export function getYouthMapIndustryInsuranceVolumeNational(params) {
  return post('/youth/map/industry/insurance/volume/national', params, { mockId: 546, isMock: false });
}

/**
 * 全国上险量查询（包含本品牌上险量）（分享）
 * https://yapi.lanhanba.com/project/349/interface/api/97572
 */
export function postShareYouthMapIndustryInsuranceVolumeNational(params) {
  return post('/spot/evaluation/share/insurance/volume/national', params, { mockId: 546, isMock: false });
}

/**
 * 上险量查询
 * https://yapi.lanhanba.com/project/546/interface/api/92924
 */
export function getYouthMapIndustryInsuranceVolume(params) {
  return post('/youth/map/industry/insurance/volume', params, { mockId: 546, isMock: false });
}

/**
 * 上险量查询（分享）
 * https://yapi.lanhanba.com/project/349/interface/api/97564
 */
export function postShareYouthMapIndustryInsuranceVolume(params) {
  return post('/spot/evaluation/share/insurance/volume', params, { mockId: 546, isMock: false });
}


/**
 * 居住人口、工作人口、常住人口、夜间客流网格热力数据
 * https://yapi.lanhanba.com/project/349/interface/api/97788
 */
export function getTargetGridHeatMap(params:any) {
  return post(`/modelCluster/hotMap/queryHeat`, params);
};


/**
 * 获取控件类型为筛选项的字段列表-（/system/storecolumnconfig页面下属性值管理）
 * https://yapi.lanhanba.com/project/546/interface/api/99028
 */
export function getShopListColumnSelection() {
  return get(`/standard/shop/setting/header/filterField/list`, {});
};

/**
 * 行业品牌按照行政区汇总
 * https://yapi.lanhanba.com/project/349/interface/api/99098
 */
export function getBrandMapCount(params: any) {
  return post(`/youth/map/brand/map/count`, params);
};


/**
 * 行业品牌按照分公司汇总
 * https://yapi.lanhanba.com/project/349/interface/api/99100
 */
export function getBranchCompanyBrandMapCount(params: any) {
  return post(`/youth/map/brand/map/count/branchCompany`, params);
};


/**
 * 管理片区列表合并围栏
 * https://yapi.lanhanba.com/project/532/interface/api/99240
 */
export function managementAreaMerge(params: any) {
  return post(`/managementArea/merge`, params);
};


/**
 * 管理片区列表
 * https://yapi.lanhanba.com/project/532/interface/api/99238
 */
export function getManagementAreaList(params: any) {
  return post(`/managementArea/pages`, params);
};

/**
 * 管理片区左侧概览
 * https://yapi.lanhanba.com/project/532/interface/api/99274
 */
export function getManagementAreView(params: any) {
  return post(`/managementArea/overview`, params);
};

/**
 * 管理片区左侧-门店列表
 * https://yapi.lanhanba.com/project/532/interface/api/99266
 */
export function getManagementShopList(params: any) {
  return post(`/managementArea/shop/list`, params, {
    needCancel: false
  });
};

/**
 * 管理片区左侧-竞品分布
 * https://yapi.lanhanba.com/project/532/interface/api/99270
 */
export function getManagementCompetitors(params: any) {
  return post(`/managementArea/competitors`, params);
};

/**
 * 管理片区左侧-商圈分布
 * https://yapi.lanhanba.com/project/532/interface/api/99272
 */
export function getManagementClusterCategory(params: any) {
  return post(`/managementArea/clusterCategory`, params);
};


/**
 * 管理片区地图hover详情
 * https://yapi.lanhanba.com/project/532/interface/api/99236
 */
export function getManagementAreDetail(params: any) {
  return post(`/managementArea/detail`, params);
};

/**
 * 新增/编辑管理片区
 * https://yapi.lanhanba.com/project/532/interface/api/99234
 */
export function managementAreInfoSave(params: any) {
  return post(`/managementArea/save`, params);
};


/**
 * 删除管理片区
 * https://yapi.lanhanba.com/project/532/interface/api/99234
 */
export function managementAreDelete(params: any) {
  return post(`/managementArea/delete`, params);
};

/**
 * 管理片区空地
 * https://yapi.lanhanba.com/project/532/interface/api/99308
 */
export function managementAreaBorderlands(params: any) {
  return post(`/managementArea/modelCapacityPlus/fileUrl`, params);
};

/**
 * 标记商圈不合适
 * https://yapi.lanhanba.com/project/644/interface/api/99398
 */
export function markClusterUnsuitable(params: any) {
  return post('/modelCluster/unsuitable/mark', params, { mockId: 644, isMock: false });
}

/**
 * 取消商圈不合适标记
 * https://yapi.lanhanba.com/project/644/interface/api/99400
 */
export function cancelClusterUnsuitable(params: any) {
  return post('/modelCluster/unsuitable/unmark', params, { mockId: 644, isMock: false });
}

/**
 * 按省/市/区维度聚合市场容量
 * https://yapi.lanhanba.com/project/349/interface/api/99546
 */
export function youthModelCapacity(params: any) {
  return post('/youth/map/modelCapacity/regionAgg', params, { mockId: 349, isMock: false });
}



/**
 * 按分公司维度聚合市场容量
 * https://yapi.lanhanba.com/project/349/interface/api/99548
 */
export function youthCompanyModelCapacity(params: any) {
  return post('/youth/map/modelCapacity/branchCompanyAgg', params, { mockId: 349, isMock: false });
}
